module.exports = __webpack_public_path__ + "img/rules_engine_option_4.b4a8150d.png";